import { render, staticRenderFns } from "./nosotros.vue?vue&type=template&id=e0bf32c4"
import script from "./nosotros.vue?vue&type=script&lang=js"
export * from "./nosotros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports